import React from 'react';
import get from 'lodash/get';
import { TextField } from '@material-ui/core';
import removeMarkdown from 'remove-markdown';
import { bool, object, string } from 'prop-types';

import { MarkdownView } from '.';
import { TruncatedTextField } from '../../components';

export const MarkdownField = ({
    record,
    source,
    stripTags = false,
    truncate,
    ...rest
}) => {
    const value = get(record, source, '');

    const removeTags = text => {
        return removeMarkdown(text);
    };

    if (stripTags) {
        const newRecord = { ...record, ...{ [source]: removeTags(value) } };
        return truncate ? (
            <TruncatedTextField record={newRecord} source={source} {...rest} />
        ) : (
            <TextField record={newRecord} source={source} {...rest} />
        );
    }

    return <MarkdownView value={value} {...rest} />;
};

MarkdownField.propTypes = {
    record: object,
    source: string,
    stripTags: bool,
    truncate: bool,
};